module.exports = __webpack_public_path__ + "img/3.4be13ff3.jpeg";